export default __webpack_public_path__ + "static/media/asset-2.797e7474.webp";